// Issue Pool Service for FlexibleCRUDTable
// Custom service that transforms issue pool data to match FlexibleCRUDTable expectations

import { issueService } from './issueService';

export class IssuePoolService {
  private issueService: typeof issueService;

  constructor() {
    this.issueService = issueService;
  }

  // Get all issues with pagination
  async getAll(params: any = {}) {
    const { page = 1, limit = 20, ...filters } = params;
    
    try {
      // Get issues using the issue service
      const issues = await this.issueService.getIssues(filters);
      
      // Apply pagination manually since getIssues doesn't support pagination yet
      const startIndex = (page - 1) * limit;
      const endIndex = startIndex + limit;
      const paginatedIssues = issues.slice(startIndex, endIndex);
      
      // Transform the data to match FlexibleCRUDTable expectations
      return {
        data: paginatedIssues,
        pagination: {
          page: page,
          limit: limit,
          total: issues.length,
          totalPages: Math.ceil(issues.length / limit)
        }
      };
    } catch (error) {
      console.error('Error fetching issue pool:', error);
      throw error;
    }
  }

  // Create a new issue
  async create(data: any) {
    return await this.issueService.createIssue(data);
  }

  // Update an issue
  async update(id: string, data: any) {
    try {
      const response = await this.issueService.updateIssue(id, data);
      return response;
    } catch (error) {
      console.error('IssuePoolService.update failed:', error);
      throw error;
    }
  }

  // Delete an issue (soft delete)
  async delete(id: string) {
    return await this.issueService.deleteIssue(id);
  }

  // Get a single issue by ID
  async getById(id: string) {
    return await this.issueService.getIssueById(id);
  }
}

export const issuePoolService = new IssuePoolService();

